"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameSearch = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var GAMES_BY_PAGE = 10;
var useGameSearch = function (_a) {
    var _b;
    var _c = _a.category, category = _c === void 0 ? undefined : _c, _d = _a.allowSearch, allowSearch = _d === void 0 ? true : _d;
    var config = (0, swr_hooks_1.useConfig)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var showGamesCountFromConfig = (0, react_1.useMemo)(function () {
        var _a, _b;
        if (!((_a = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _a === void 0 ? void 0 : _a.home))
            return null;
        var settings = (_b = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _b === void 0 ? void 0 : _b.home;
        if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile384) || (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile460)) && (settings === null || settings === void 0 ? void 0 : settings['xs']))
            return settings === null || settings === void 0 ? void 0 : settings['xs'];
        if (((breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile550) ||
            (breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile660) ||
            breakpoints.mobile767) &&
            (settings === null || settings === void 0 ? void 0 : settings['mobile']))
            return settings === null || settings === void 0 ? void 0 : settings['mobile'];
        if (breakpoints.tablet && (settings === null || settings === void 0 ? void 0 : settings['tablet']))
            return settings === null || settings === void 0 ? void 0 : settings['tablet'];
        return settings === null || settings === void 0 ? void 0 : settings['default'];
    }, [breakpoints, (_b = config === null || config === void 0 ? void 0 : config.showGamesByPage) === null || _b === void 0 ? void 0 : _b.home]);
    var _e = (0, swr_hooks_1.useSearchGamesByFilters)({
        showCount: showGamesCountFromConfig
            ? showGamesCountFromConfig
            : breakpoints.tablet || breakpoints.mobile
                ? 9
                : GAMES_BY_PAGE,
        category: category,
        allowSearch: allowSearch,
    }), data = _e.data, searchValue = _e.searchValue, onLoadBtnClick = _e.onLoadBtnClick, onSearchClear = _e.onSearchClear, onFiltersClear = _e.onFiltersClear, onSearchChange = _e.onSearchChange, isSubmitting = _e.isSubmitting;
    var searchResults = (0, react_1.useMemo)(function () { return (data === null || data === void 0 ? void 0 : data.data.edges) || []; }, [data]);
    var searchGamesCount = (data === null || data === void 0 ? void 0 : data.data.totalCount) || 0;
    var isShowLoadMore = searchGamesCount > (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length);
    return {
        searchValue: searchValue,
        onLoadBtnClick: onLoadBtnClick,
        onSearchClear: onSearchClear,
        onFiltersClear: onFiltersClear,
        onSearchChange: onSearchChange,
        isSubmitting: isSubmitting,
        searchResults: searchResults,
        isShowLoadMore: isShowLoadMore,
    };
};
exports.useGameSearch = useGameSearch;
